import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { getApiCall } from "../../../service/getApiCall";
import { postApiCall } from "../../../service/postApiCall";
import { API_TTS_CREATE, API_TTS_UPDATE } from "../../../service/url";
import { Dropdown } from "primereact/dropdown";
import { toast } from 'react-toastify';
import { getUser } from "../../../utilities/setting";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../utilities/constant";
import { fetchAndSetFlashMessage } from '../../../service/fetchFlashMessage';
import {FLASH_MESSAGE_ACTION_OBJECT, MODULE_ACL } from '../../../utilities/constant';

const AddTTS = () => {
  const navigate = useNavigate();
  const my_api = "https://abc.com";
  const [language, setLanguage] = useState("");
  const [gender, setGender] = useState("");
  const [fileName, setFileName] = useState("");
  const [textScript, setTextScript] = useState("");
  const [categories, setCategories] = useState([]);
  const [sendCategory, setSendcategory] = useState(null);
  const [userId, setUserId] = useState(null);
  const [ttslanguages, setTtslanguages] = useState([]);
  const [ttsFileData, setTtsFileData] = useState(null);
  const [enableTtsOptions, setEnableTtsOptions] = useState(false);
  const [showListenModal, setShowListenModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);

  useEffect(() => {
    const resp = getUser();
      if (resp) {
        setUserId(resp.id);
      }
        fetchAndSetFlashMessage(
            msg => msg.module_name === MODULE_ACL.TTS && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Flash Message',
            setAlertMessage
        );
  }, []);

  // Function to validate text based on selected language script
  const isValidText = (text, lang) => {
    if (!lang || !text) return true;
    let regex;
    switch (lang) {
      case "hi-IN":
        // Devanagari script + spaces, digits, common punctuation
        regex = /^[\u0900-\u097F\s\d.,!?;:'"()\[\]{}-]*$/;
        break;
      case "eng-IN":
        // Latin script (English) + spaces, digits, common punctuation
        regex = /^[A-Za-z0-9\s.,!?;:'"()\[\]{}-]*$/;
        break;
      case "pi-IN":
        // Gurmukhi script (Punjabi) + spaces, digits, common punctuation
        regex = /^[\u0A00-\u0A7F\s\d.,!?;:'"()\[\]{}-]*$/;
        break;
      default:
        return true;
    }
    return regex.test(text);
  };

  // Handle text script change with validation
  const handleTextScriptChange = (e) => {
    if (!language) {
      return; // Prevent any input until language is selected
    }
    const newText = e.target.value;
    if (isValidText(newText, language)) {
      setTextScript(newText);
    }
    // If invalid, do not update state (reverts to previous valid text)
    // Optionally, you can add a toast/warning here for user feedback
  };

  // Effect to validate existing text when language changes
  useEffect(() => {
    if (language && textScript && !isValidText(textScript, language)) {
      setTextScript("");
    }
  }, [language]);

  const handleSubmit = async () => {
    return;
    setEnableTtsOptions(false);
    if (!userId) {
      toast.warning("User id Required");
      return;
    }
    if (
      !language ||
      !fileName?.trim() ||
      !gender ||
      !textScript?.trim() ||
      !sendCategory
    ) {
      toast.warning("All fields are Required")
      return;
    }
    const payload = {
      category: sendCategory,
      characterCount: textScript.length,
      filename: fileName,
      gender,
      language,
      textScript,
      userId: userId,
    };
    try {
      const response = await fetch(my_api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (response.ok) {
        if (data) {
          setShowListenModal(true);
          setTtsFileData(data);
        }
        const payload = {
          category: sendCategory,
          character_count: textScript.length,
          tts_url: data?.downloadUrl,
          file_name: fileName,
          gender,
          language,
          text_script: textScript,
          status: 0,
        };
        await postApiCall(API_TTS_CREATE, payload);
        setEnableTtsOptions(true);
      } else {
        toast.error(data.message || "Something went wrong.")
      }
    } catch (error) {
      toast.warning(JSON.stringify(error))
    } finally {
      setEnableTtsOptions(false);
    }
  };

  const handleSaveTts = async (status) => {
    setEnableTtsOptions(false);
    if (
      !language ||
      !fileName?.trim() ||
      !gender ||
      !textScript?.trim() ||
      !sendCategory
    ) {
      toast.warning("All fields are Required")
      return;
    }
    const payload = {
      status: status ? 1 : 2,
      tts_id: ttsFileData?.ttsId,
    };
    try {
      const url = API_TTS_UPDATE.replace(":id", ttsFileData?.ttsId);
      const response = await postApiCall(url, payload);
      if (response.ok && !status) {
        toast.success("TTS Added Successfully!")
        setTimeout(() => {
          navigate(ROUTES.TTS.LIST);
        }, 2000);
      }
    } catch (error) {
      console.log("Error submitting tts", error);
      if (!status) {
        toast.warning(JSON.stringify(error))
      }
    } finally {
      setEnableTtsOptions(true);
      if (!status) {
        setLanguage("");
        setGender("");
        setFileName("");
        setTextScript("");
        setSendcategory(null);
        setTtsFileData(null);
      }
    }
  };

  const fetchCategories = () => {
    getApiCall("/v2/voice-category").then((response) => {
      if (response && response.categories) {
        setCategories(response.categories);
      }
    });
  };

  const fetchTtslanguages = () => {
    getApiCall("/v2/tts-languages").then((response) => {
      if (response) {
        setTtslanguages(response);
      }
    });
  };

  useEffect(() => {
    fetchCategories();
    fetchTtslanguages();
  }, []);

  return (
    <>
        {alertMessage && <div className="alert alert-success marquee-container" style={{ marginTop: "5px" }}>
          <span className="marquee-text" style={{'--marquee-duration': `${(alertMessage.length * 0.2) + 15}s`}}>{alertMessage}</span>
        </div>}
      <div className="container">
        <Card className="shadow-sm p-3">
          <h5 className="fw-semibold mb-3">ADD TTS</h5>
          <Form>
            {/* Row 1 */}
            <Row className="mb-3">
              <Col md={6} className="mb-2">
               <Form.Label >Select Language: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                <Form.Select
                  size="sm"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <option value="">Select Language</option>
                  {ttslanguages?.map((item) => {
                    return <option value={item?.code}>{item?.language}</option>;
                  })}
                </Form.Select>
              </Col>
              <Col md={6} className="mb-2">
              <Form.Label>Select Gender: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                <Form.Select
                  size="sm"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option value="">Select Gender</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                </Form.Select>
              </Col>
            </Row>
            {/* Row 2 */}
            <Row className="mb-3">
              <Col md={6} className="mb-2">
               <Form.Label >Select Category: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                <Form.Select
  id="category"
  value={sendCategory || ""}
  onChange={(e) => setSendcategory(e.target.value)}
  className="form-control p-column-filter my-dropdown"
  style={{
    height: "50%",
  }}
>
  <option value="">Select Category</option>

  {categories.map((item) => (
    <option key={item} value={item}>
      {item}
    </option>
  ))}
</Form.Select>
              </Col>
              <Col md={6} className="mb-2">
               <Form.Label >File Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="File Name"
                  value={fileName}
                  onChange={(e) => setFileName(e.target.value)}
                />
              </Col>
            </Row>
            {/* Text Script */}
            <Form.Label className="fw-semibold">Text Script <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Control
              as="textarea"
              value={textScript}
              onChange={handleTextScriptChange}
              placeholder={
                !language
                  ? "Select language first to enter text"
                  : "Enter Text Script"
              }
              disabled={!language}
              style={{
                height: "130px",
                fontSize: "14px",
                resize: "none",
              }}
            />
            <small className="text-muted">
              Entered Text Script Length : {textScript.length}
            </small>
            {/* Buttons */}
            <div className="d-flex gap-2 mt-3">
              <Button
                size="sm"
                variant="primary"
                onClick={handleSubmit}
                loading={enableTtsOptions}
                disabled={enableTtsOptions}
              >
                Submit
              </Button>
              <Button
                size="sm"
                variant="secondary"
                disabled={!enableTtsOptions}
              >
                Listen
              </Button>
              <Button
                size="sm"
                variant="danger"
                disabled={!enableTtsOptions}
                loading={enableTtsOptions}
                onClick={() => handleSaveTts(false)}
              >
                Discard
              </Button>
              <Button
                size="sm"
                variant="info"
                className="text-white"
                disabled={!enableTtsOptions}
                loading={enableTtsOptions}
                onClick={() => handleSaveTts(true)}
              >
                Save
              </Button>
            </div>
          </Form>
        </Card>
      </div>
      <Dialog
        header="TTS Playback"
        visible={showListenModal && ttsFileData?.downloadUrl}
        style={{
          width: "40vw",
          position: "absolute",
          top: "10px",
          left: "50%",
          transform: "translateX(-50%)",
        }}
        onHide={() => setShowListenModal(false)}
      >
        <audio controls style={{ width: "100%" }}>
          <source src={ttsFileData?.downloadUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </Dialog>
    </>
  );
};

export default AddTTS;
